module.exports = __webpack_public_path__ + "static/media/icon_copy-to-clipboard.6e34ff6e.svg";